/** @jsxImportSource theme-ui */
import { useBreakpointIndex } from '@theme-ui/match-media';
import React from 'react';
import { Divider, Menu } from 'semantic-ui-react';

import { isMobile } from 'utils/responsive';
import { toAbsoluteAuthUrl } from 'utils/urlHelpers';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

import BlueDotLogoSvg from 'assets/bluedot-logo.svg';

const SettingsFooter: React.FC = () => {
  const isMobileDevice = isMobile(useBreakpointIndex());

  return (
    <div data-testid="settingFooter">
      <Divider section />
      <footer sx={{ mb: '20px' }}>
        <FlexGroup
          stackable
          sx={{ width: '100%' }}
          suffix={
            <Menu secondary className="footer-menu" vertical={isMobileDevice}>
              <Menu.Item
                as="a"
                name="Privacy policy"
                href={toAbsoluteAuthUrl('/BlueDot/PrivacyPolicy')}
              />
              <Menu.Item
                as="a"
                name="Contact Us"
                href="https://bluedot.global/contact"
                target="_blank"
              />
            </Menu>
          }
        >
          <Typography
            variant="h6"
            color="deepSea100"
            marginBottom="10px"
            sx={{
              verticalAlign: 'middle',
              whiteSpace: 'nowrap',
            }}
          >
            &copy;{' '}
            <img
              sx={{ verticalAlign: 'middle', marginLeft: '-6px' }}
              src={BlueDotLogoSvg}
              alt="BlueDot logo"
              height="30"
            />
          </Typography>
        </FlexGroup>
      </footer>
    </div>
  );
};

export default SettingsFooter;
